import React, { useEffect, useState } from "react";
import { Menu, X, Linkedin } from "lucide-react";
import { NAV_LINKS, CONTACT } from "../mock";
import Logo from "./Logo";

export const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
  else window.location.assign(`/#${id}`);
};

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [tag, setTag] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    const onPhase = (e) => setTag(e.detail || "");
    window.addEventListener("scroll", onScroll);
    window.addEventListener("arlan:phase", onPhase);
    return () => { window.removeEventListener("scroll", onScroll); window.removeEventListener("arlan:phase", onPhase); };
  }, []);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollTo(id), 50);
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${scrolled ? "bg-[#191919]/90 backdrop-blur-md" : "bg-transparent"}`}
        data-testid="navbar"
      >
        <nav className="relative h-[96px] px-6 lg:px-12 flex items-center justify-between">
          <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors" aria-label="LinkedIn" data-testid="nav-linkedin">
            <Linkedin className="w-5 h-5" />
          </a>

          <button onClick={() => go("top")} className="absolute left-1/2 -translate-x-1/2 text-white hover:opacity-90 transition-opacity flex flex-col items-center" data-testid="nav-logo" aria-label="Arlan · Inicio">
            <Logo height={44} className="hidden sm:block" />
            <Logo height={36} className="sm:hidden" />
            <span
              className={`text-[0.62rem] font-semibold tracking-[0.32em] uppercase transition-all duration-500 ${tag ? "opacity-100 translate-y-0 mt-1.5" : "opacity-0 -translate-y-1 mt-0 h-0"}`}
              style={{ color: "var(--green-light)" }}
              data-testid="nav-tag"
            >
              {tag}
            </span>
          </button>

          <button onClick={() => setOpen(true)} className="text-white/90 hover:text-white" aria-label="Menú" data-testid="nav-menu-toggle">
            <Menu className="w-7 h-7" strokeWidth={1.5} />
          </button>
        </nav>
      </header>

      <div
        className={`fixed inset-0 z-[60] bg-1 dots transition-opacity duration-300 ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        data-testid="nav-overlay"
      >
        <div className="absolute top-7 left-6 lg:left-12 text-white"><Logo height={40} /></div>
        <button onClick={() => setOpen(false)} className="absolute top-7 right-6 lg:right-12 text-white/80 hover:text-white" aria-label="Cerrar" data-testid="nav-menu-close">
          <X className="w-8 h-8" strokeWidth={1.5} />
        </button>
        <div className="h-full max-w-6xl mx-auto px-6 lg:px-12 flex flex-col lg:flex-row lg:items-center gap-12 pt-28 lg:pt-0 overflow-y-auto">
          <ul className="flex-1 space-y-2 lg:space-y-4">
            {NAV_LINKS.map((l, i) => (
              <li key={l.id}>
                <button
                  onClick={() => go(l.id)}
                  className="text-3xl lg:text-5xl font-medium text-white/85 hover:text-white hover:pl-3 transition-all duration-200 flex items-baseline gap-4"
                  data-testid={`nav-link-${l.id}`}
                >
                  <span className="text-green text-xs tracking-widest">0{i + 1}</span>
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
          <div className="lg:w-80 space-y-5 text-sm pb-10">
            <p className="label">Contacto</p>
            <p className="text-white/80">Solicitud de estudio a través del formulario.</p>
            <p className="text-muted">Mutilva (Navarra) · Madrid</p>
            <button onClick={() => go("contacto")} className="btn-pill mt-4" data-testid="nav-overlay-cta">
              Contactar
              <span className="circle">→</span>
            </button>
          </div>
        </div>
      </div>

      <div className="scroll-hint hidden lg:flex" aria-hidden="true">
        SCROLL
        <span className="bar" />
      </div>
    </>
  );
};

export default Navbar;
